import { render } from "./NotasComponent.vue?vue&type=template&id=4ec9d7dd"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__